import { render, staticRenderFns } from "./AlarmUpgradeComp.vue?vue&type=template&id=1c608edc&scoped=true&"
import script from "./AlarmUpgradeComp.vue?vue&type=script&lang=js&"
export * from "./AlarmUpgradeComp.vue?vue&type=script&lang=js&"
import style0 from "./AlarmUpgradeComp.vue?vue&type=style&index=0&id=1c608edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c608edc",
  null
  
)

export default component.exports